/**
 * Returns a callback to initialize the slick behavior.
 * @param {Element} component
 * @return {Function} A callback function
 */
const handleCompactCardInit = (component) => () => {
    const $pager = $('<span data-gallery-pager>');

    $(component)
        .on('init', () => {
            $(component).append($pager);
        }).slick({
            slidesToShow: 2.5,
            slidesToScroll: 1,
            focusOnSelect: false,
            centerMode: false,
            dots: true,
            arrows: true,
            prevArrow: '<button class="slick-prev slick-arrow button button--teaser-text-only slick-arrow"></Button>',
            nextArrow: '<button class="slick-next slick-arrow button button--teaser-text-only slick-arrow"></Button>',
            adaptiveHeight: true,
            rows: 1,
            swipeToSlide: true,
            draggable: true,
            touchMove: true,
            infinite: false,
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 2,
                        arrows: false,
                    },
                },
                {
                    breakpoint: 786,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true,
                        centerPadding: '4px',
                        arrows: false,
                    },
                },
            ],
        });
};

export default handleCompactCardInit;



// WEBPACK FOOTER //
// ./src/scripts/components/gallery/handleCompactCardInit.js